import React from 'react';

import Participant from 'views/Home/Monitoring/ParticipantList/Participant';

import { getInitiationType } from 'views/Home/Monitoring/utils';

import type { CallConnection } from 'store/call/call.state';

import styles from './participant-list.module.scss';

export type Props = {
    connections: CallConnection[];
};

const ParticipantList: React.FC<Props> = ({ connections }) => {
    return (
        <ul aria-label="Participant list" className={styles.list}>
            {connections.map(connection => {
                const { id, name, type = 'UNKNOWN', start, status } = connection;

                const initiationType = getInitiationType(type, status);

                return (
                    <Participant
                        key={id}
                        name={name}
                        initiationType={initiationType}
                        type={type}
                        initiationDate={start}
                    />
                );
            })}
        </ul>
    );
};

export default ParticipantList;
